export function drawLine({ text = 'TOP', pointIndex = 0, color = "#ff0000" }) {
    return function (chart) {
        const meta = chart.getDatasetMeta(0); // first dataset is used to discover X coordinate of a point
        const data = meta.data;

        if (data && !data.length) return;

        const lineLeftOffset = data[pointIndex]._model.x;

        const scale = chart.scales['y-axis-0'];
        const context = chart.chart.ctx;

        // render vertical line
        context.beginPath();
        context.strokeStyle = '#3b8a57';
        // context.strokeStyle = color; // '#ff0000';
        context.moveTo(lineLeftOffset, scale.top + 25);
        context.lineTo(lineLeftOffset, scale.bottom);
        context.stroke();

        // write label
        context.fillStyle = '#3b8a57';
        // context.fillStyle = color; // '#ff0000';
        context.textAlign = 'center';
        const textTop = (scale.bottom - scale.top) / 2 + scale.top;
        context.fillText(text, lineLeftOffset, textTop - 80);
    }
}
